module.exports = __webpack_public_path__ + "static/Haselnuss-7d8ea4c901268b1180cbf0eedd0bac94.png";